const colors = {
	primary: 'rgba(215, 80, 85, 1)',
	primaryShaded: 'rgba(179, 210, 38, 1)',
	secondary: 'rgba(0, 87, 86, 1)',
	secondaryShaded: 'rgba(6, 58, 73, 1)',
	secondaryLight: 'rgba(206, 219, 218, 1)',
	tertiary: 'rgba(145, 174, 193, 1)',
	tertiaryShaded: 'rgba(54, 14, 65, 1)',
	quatiary: 'rgba(0, 217, 192, 1)',
	quatiaryShaded: 'rgba(0, 174, 154, 1)',

	patflow: 'rgba(21, 56, 79, 1)',
	category_2: 'rgba(0, 87, 86, 1)',
	category_3: 'rgba(232, 32, 66, 1)',
	category_4: 'rgba(206, 169, 255, 1)',

	dark: 'rgba(22, 22, 22, 1)',
	light: 'rgba(249, 249, 249, 1)',
	white: 'rgba(255, 255, 255, 1)',

	grey: 'rgba(166, 166, 166, 1)', // oder rgba(188, 188, 188, 1)
	lightgrey: 'rgba(243, 243, 244, 1)',
	darkgrey: 'rgba(55, 55, 55, 1)'
};

export default colors;

